<template>

  
        <DBox
            :id="'cmp-catalog-releases-sidewindow-related_contact'"
            :addButton="false"
            :addLink="true"
            :addLinkLabel="`${$t('add_new')} ${$t('related_contact')}`"
            @add_click="onAddRelatedLinks"
        >
            <NTable
                class="dbox1"
                id="catalog-releases-related-related_contact"
                :config="tableConfig"
                :headers="Headers"
                :items="list"
                height="170px"
            
            >
            <template v-slot:item="{ item, tdcon }">
                <tr
                 
                >
                   <td v-bind="tdcon('related_contacts')">
                          <TextField2
                            type="text"
                            class="dbox1"
                            id="relation"
                            :showLabel="false"
                            :disabled="false"
                            :value="item['relation']"
                            :bb="'0px'"
                            @change="e => onTextFieldChange(e, item)"
                        />
                    </td>
                    <td v-bind="tdcon('genre_name')">
                         <span >{{
                            item["contact_name"]}}
                        </span>
                    </td>
                    <td v-bind="tdcon('phone')">
                      <span >{{
                            item["phone1"]}}
                        </span>
                   
                    </td>
                     <td v-bind="tdcon('email')">
                      <span >{{
                            item["email1"]}}
                        </span>
                   
                    </td>
                
                    
                </tr>
            </template>
            </NTable>
      
        </DBox>
  
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from '../../../../plugins/datatable';
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";

export default {
  props: {
    contactRelations: {
        type: Array,
    },


  },
  components: {
        NTable,
        DBox
   
  },
  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },
      releaseArtist:'',
      releaseTitle:'',
      releaseDate:'',
      releaseCode:'',
      tableConfig: createNTableConfig({
        headerStyle: 3
      }),
  
    };
  },
  computed:{
        Headers: function () {
            return [
                createTableHeader("related_contacts", {  }),
                createTableHeader("genre_name", { }),
                createTableHeader("phone", { }),
                createTableHeader("email", { }),
                
             
                
              
            ];
        },

        list:function(){
            return this.contactRelations||[]
        },

      
  },

  
  methods:{
    onTextFieldChange:function (e, item) {
      const payload={
        name:e.name,
        value:e.value,
        item:item
      }
      this.$emit("change",payload)
      console.log("WEJJPPPO",payload)
    },
    onDropdownChange:function(){

    },
    onDateChange:function(){
      
    },
    onAddRelatedLinks:function(){

    }

  }

}
</script>
<style lang="scss">
.cmp-catalog-releases-sidewindow-related_contact{
  
  .dt-ntable {
    --ntable-height: 170px;
  }

}
</style>
